import axios from 'axios';

const apiLmsManager = axios.create({
  baseURL: process.env.REACT_APP_LMS_MANAGER_API_URL
});

apiLmsManager.interceptors.request.use(async config => {
  config.headers['Content-type'] = `application/json`;
  if (
    config.url !== '/login_check' &&
    config.url !== '/reset-password' &&
    config.url !== '/reset-password/alterar-senha' &&
    config.url !== '/empresa/logo'
  ) {
    const token = localStorage.getItem('@RockfellerToken');
    token
      ? (config.headers['Authorization'] = `Bearer ${token}`)
      : (window.location.href = '/login');
  }

  return config;
});

apiLmsManager.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    if (
      error.response.status === 401 &&
      error.response.config.url === '/token/refresh'
    ) {
      localStorage.removeItem('@RockfellerToken');
      localStorage.removeItem('@RockfellerRefreshToken');
      localStorage.removeItem('@RockfellerType');
      window.location.href = '/login';
    } else if (
      error.response.status === 401 &&
      localStorage.getItem('@RockfellerRefreshToken') &&
      error.response.config.url !== '/login_check'
    ) {
      const refreshToken = await apiLmsManager.post('/token/refresh', {
        refresh_token: localStorage.getItem('@RockfellerRefreshToken')
      });

      localStorage.setItem('@RockfellerToken', refreshToken.data.token);
      localStorage.setItem(
        '@RockfellerRefreshToken',
        refreshToken.data.refresh_token
      );
      //localStorage.setItem('@RockfellerType', refreshToken.data.type);
      window.location.href = window.location.pathname;

      const requestConfig = error.config;
      localStorage.removeItem('LOGO');
      return axios(requestConfig);
    } else if (error.response.status === 401 || error.response.status === 403) {
      localStorage.removeItem('@RockfellerToken');
      localStorage.removeItem('LOGO');
      //window.location.href = '/login';
      const requestConfig = error.config;
      return axios(requestConfig);
    }
    return Promise.reject(error);
  }
);

export default apiLmsManager;
